import React, { PureComponent } from 'react';

import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import { UserPhoto } from 'components/user';
import { USER_ROLES_LABEL } from 'modules/userManager/constants';
import PropTypes from 'prop-types';

import './PlusAccessModal.scss';

export default class PlusAccessModal extends PureComponent {
  static propTypes = {
    closeModal: PropTypes.func,
    userPlusAccess: PropTypes.string,
    dependents: PropTypes.object
  };

  getRole(userRole) {
    return !userRole
      ? 'general.pending_invitation'
      : USER_ROLES_LABEL[userRole];
  }

  dependentItem(dependent, index) {
    return (
      <div key={`dependent-item-${index}`} className="user-info">
        {dependent.requestPending ? (
          <i className="icon icon-hourglass" />
        ) : (
          <UserPhoto name={dependent.userEmail} />
        )}

        <div>
          <div className="user-info__email">{dependent.userEmail}</div>
          <div className="user-info__role">
            <I18n label={this.getRole(dependent.userRole)} />
          </div>
        </div>
      </div>
    );
  }

  get typeLabel() {
    const { userPlusAccess } = this.props;

    return userPlusAccess === 'DEPENDENT'
      ? 'general.dependant'
      : 'general.holder';
  }

  render() {
    const { closeModal, dependents } = this.props;

    return (
      <Modal
        title="sales_manager.access_plus"
        headerTitle="general.details"
        onClose={closeModal}
        hideWarn={true}
        className="plus__access__modal"
      >
        <Modal.Header>
          <p className="title__label">
            <I18n label="general.status" />
          </p>
          <p>
            <I18n label={this.typeLabel} />
          </p>
        </Modal.Header>
        <Modal.Body>
          <p className="title__label">
            <I18n label="users_manager.deep_search.access.access_plus_type_user_options.dependants" />
          </p>

          {dependents.map(this.dependentItem.bind(this))}
        </Modal.Body>
      </Modal>
    );
  }
}
